import equals from 'ramda/es/equals';
import { describeValue } from 'utils/describeValue';
import { CUSTOM_WORKLIST_FILTERS_IN_FLIGHT_KEY } from '../Worklist/WorklistPageV2/constants';
import { WorklistFilters } from './types';

// Values here are fixed options or internal smids, never patient data.
// Any other key is described, so a new filter fails safe.
const LOGGABLE_FILTER_KEYS = new Set<string>([
  WorklistFilters.BodyPart,
  WorklistFilters.CriticalResult,
  WorklistFilters.CustomStatus,
  WorklistFilters.ExamCode,
  WorklistFilters.ExamStatus,
  WorklistFilters.HasDraftReport,
  WorklistFilters.Modality,
  WorklistFilters.PatientType,
  WorklistFilters.Priority,
  WorklistFilters.QcStatus,
  WorklistFilters.ReportExtendedStatus,
  WorklistFilters.Site,
  WorklistFilters.Status,
  WorklistFilters.Views,
  CUSTOM_WORKLIST_FILTERS_IN_FLIGHT_KEY,
]);

/**
 * Safe-to-log view of a filter object: fixed-option values as-is, everything else as a
 * value shape (length, words, has comma...). Never the value itself.
 */
export function describeFilters(filters: Nullable<Record<string, unknown>>) {
  if (filters == null) return filters;

  return Object.fromEntries(
    Object.entries(filters).map(([key, value]) => [
      key,
      LOGGABLE_FILTER_KEYS.has(key) ? value : describeValue(value),
    ])
  );
}

export function getChangedFilterKeys(
  previous: Nullable<Record<string, unknown>>,
  next: Nullable<Record<string, unknown>>
): string[] {
  const keys = new Set([...Object.keys(previous ?? {}), ...Object.keys(next ?? {})]);
  return [...keys].filter((key) => !equals(previous?.[key], next?.[key]));
}
